import { MessageCircle } from 'lucide-react';
import { Button, cx } from './charte';

/**
 * « Écrire à mon auto-école » : ouvre « Messages » (J26, 28/10/2026). Sous les messages qui disent de contacter
 * l'auto-école pour une leçon : leçon planifiée par elle, annulation en ligne refusée.
 */
export function SchoolMessagesLink({ onOpen, className }: { onOpen: () => void; className?: string }) {
  return (
    <Button variant="link" size="sm" icon={MessageCircle} className={cx('mt-1.5 flex', className)} onClick={onOpen}>
      Écrire à mon auto-école
    </Button>
  );
}
